// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { UserViewModel } from './userview-model';
import { NotificationViewModel } from './notificationview-model';


export class TeacherNotificationsViewModel {
    currentUser: UserViewModel = null;
	notifications: NotificationViewModel[] = null;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        
	}
}